// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';

// OpenAI API Configuration
export const OPENAI_CONFIG = {
  endpoint: process.env.REACT_APP_OPENAI_API_ENDPOINT || 'https://api.openai.com/v1/chat/completions',
  apiKey: process.env.REACT_APP_OPENAI_API_KEY,
  model: 'gpt-4',
  maxTokens: 2000,
  temperature: 0.7,
  topP: 0.9,
  frequencyPenalty: 0.5,
  presencePenalty: 0.5
};

// Cache Configuration
export const CACHE_CONFIG = {
  TTL: 5 * 60 * 1000, // 5 minutes in milliseconds
  PREFIX: 'ai_insights_'
};

// Feature Flags
export const FEATURE_FLAGS = {
  ENABLE_AI_INSIGHTS: process.env.REACT_APP_ENABLE_AI_INSIGHTS === 'true',
  ENABLE_CACHING: process.env.REACT_APP_ENABLE_CACHING !== 'false',
  ENABLE_REAL_TIME_UPDATES: process.env.REACT_APP_ENABLE_REAL_TIME_UPDATES === 'true'
}; 